import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["rows"];

  addRow(event) {
    event.preventDefault();
    const row = document.createElement("tr");
    row.innerHTML = `
      <td><input type="text" name="organization[ipa_words][]" class="form-control"></td>
      <td><input type="text" name="organization[ipa_phonemes][]" class="form-control"></td>
      <td><a href="#" class="delete-ipa-row" data-action="click->ipa-lexicon#removeRow">remove</a></td>
    `;
    this.rowsTarget.appendChild(row);
  }

  removeRow(event) {
    event.preventDefault();
    event.target.closest("tr").remove();
  }
}
